import React from 'react';
import { normalizeSiteContentLineBreaks } from '../utils/siteContentText';

type SiteContentTextProps = {
  text: string;
  className?: string;
  as?: 'p' | 'div' | 'span';
};

const SiteContentText: React.FC<SiteContentTextProps> = ({
  text,
  className = '',
  as: Tag = 'div',
}) => {
  const normalized = normalizeSiteContentLineBreaks(text);
  if (!normalized) return null;

  return <Tag className={`whitespace-pre-line ${className}`.trim()}>{normalized}</Tag>;
};

export default SiteContentText;
